import { Link, useLocation } from "react-router-dom";
import { Settings2, ScrollText, Users, CreditCard } from "lucide-react";
import { SETTINGS } from "@/constants/testIds";

const TABS = [
  { to: "/settings/workspace", label: "Workspace", icon: Settings2, testid: SETTINGS.tabWorkspace },
  { to: "/settings/billing", label: "Billing", icon: CreditCard, testid: SETTINGS.tabBilling },
  { to: "/settings/audit", label: "Audit log", icon: ScrollText, testid: SETTINGS.tabAudit },
  { to: "/team", label: "Members", icon: Users, testid: SETTINGS.tabMembers },
];

export function SettingsTabs() {
  const { pathname } = useLocation();
  return (
    <nav className="mt-6 flex flex-wrap items-center gap-1.5 border-b border-border/60 pb-px">
      {TABS.map(({ to, label, icon: Icon, testid }) => {
        const active = pathname === to;
        return (
          <Link
            key={to}
            to={to}
            data-testid={testid}
            className={`inline-flex items-center gap-2 rounded-t-md border-b-2 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.16em] transition-colors ${
              active
                ? "border-accent text-accent"
                : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className="h-3.5 w-3.5" />
            {label}
          </Link>
        );
      })}
    </nav>
  );
}
